import { signOut } from 'firebase/auth';
import { auth } from '../firebase-config';
import { clearSupportSession } from '../modules/support-session';

export const logout = async () => {
  // Log the user out
  await Promise.all([clearSupportSession(), signOut(auth)]);

  // Redirect the user to the home page
  window.location.href = '/';
};
